import { FC, useState, useEffect } from 'react';
import { Button, Confirm, Icon, Modal, Dimmer, Loader, ModalProps } from 'semantic-ui-react';
import { api, useApi } from '../api/api';
import { EventFilter } from '../api/events';

interface Props extends ModalProps {
    filter: EventFilter;
    onClose: () => void;
}

const DeleteEventsWindow: FC<Props> = (props) => {
    const eventsApi = useApi(api.events);
    const [action, setAction] = useState('');

    const [processing, setProcessing] = useState(false);

    const { filter, onClose, onDeleteClicked } = props;

    const onChange_SetAction = (event : any) => {
        setAction(event.target.value)
    }

    const deleteEvents = (events: any[]) => {
        let idsToRemove = new Array<string>();
        events.forEach((item: any) => {
            idsToRemove.push(item.objectId);
        });
        eventsApi.removeByIds(idsToRemove);
    }

    const onClick_DoDeleteEvents = (event: any) => {
        setProcessing(true);

        if (action == 'current') {
            return eventsApi
                .index(filter, 1, 10000)
                .then(({ items, count }) => {
                    deleteEvents(items);
                })
                .catch(e => console.error(e))
                .finally(() => {
                    setProcessing(false);
                    onClose(); // notify parent to close modal form
                    onDeleteClicked(); // notify parent to reload table
                });
        } else if (action == 'allmissing') {
            return eventsApi
                .removeAllWithoutSource()
                .catch(e => console.error(e))
                .finally(() => {
                    setProcessing(false);
                    onClose(); // notify parent to close modal form
                    onDeleteClicked(); // notify parent to reload table
                });
        } else {
            console.error("Got unimplemented action: " + action);
            setProcessing(false);
        }
    }

    return (
        <Modal
            size='large'
            style={{ minWidth: '50%', maxWidth: '95%' }}
            closeIcon
            open={true}
            onClose={onClose}
        >

            <Modal.Header>Delete Events</Modal.Header>
            <Modal.Content scrolling>
            {processing ?
                <Dimmer inverted active={true}><Loader/></Dimmer>
            :
                <>
                    <p>Please select:</p>
                    <div onChange={onChange_SetAction}>
                        <label>
                            <input type="radio" name="deleteEvents" value="current" disabled={filter.length == 0}/>
                            Delete current filter events {filter.length == 0 ? "(no filters selected)" : ""}
                        </label>
                        {action && action == 'current' ?
                            <>
                                <p>Current filter:</p>
                                <ul>
                                    {filter.map((item) => <li>{item.field}: {item.value}</li>)}
                                </ul>
                            </>
                        :
                            <br/>
                        }
                        <label>
                            <input type="radio" name="deleteEvents" value="allmissing" />
                            Delete all missing source events
                        </label>
                        {action && action == 'allmissing' && <p style={{color:'red'}}>It will remove all events with empty sources</p>}
                    </div>
                </>
            }
            </Modal.Content>

            <Modal.Actions>
                <Button circular disabled={!action || action == ''} onClick={onClick_DoDeleteEvents}>
                    Run
                </Button>

                <Button circular onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
  )
}

export default DeleteEventsWindow;